
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: 'Activate new accounts with the industry\'s top performing direct deposit and bill switching solution, The Pinwheel Switch Kit.'
};
export const partnerProps = {
  partner: 'Pinwheel',
  clientLibrary: 'pinwheel',
  subtitle: metadata.description,
  registrationUrl: 'https://www.pinwheelapi.com/company/contact-us',
  apiUrl: 'https://docs.pinwheelapi.com/public/docs/switch-kit',
  isPaymentProcessor: false
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Pinwheel and Plaid have partnered to revolutionize how financial institutions activate new customers day 1, with in-app direct deposit and bill switching at account opening. By integrating The Pinwheel Switch Kit through Plaid Link, financial institutions can offer users a secure, frictionless experience to switch their direct deposit and recurring bills to their new account. The Pinwheel Switch Kit is the only solution in market to combine both credential-less payroll authentication and automatic bill detection with 1-click switching.`}</p>
    <p>{`Switch Kit leverages Plaid's trusted infrastructure to handle authentication and transaction data retrieval of external accounts. Embedding Pinwheel Switch Kit powered by Plaid enables banks and credit unions to achieve primacy on day 1.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.TransactionsInstructions {...partnerProps} />
    <Partnership.TransactionsServer {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.TransactionsConclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
